import { useState, useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import axios from 'axios';

const useFacebookPixel = (usuario) => {
  const [pixelId, setPixelId] = useState(null);

  useEffect(() => {
    if (!usuario) return;

    const fetchPixel = async () => {
      try {
        const response = await axios.get(`https://api.mrcirp.com/public/userpixels/${usuario}`);
        if (response.data && response.data.length > 0) {
          const pixelId = response.data[0].pixels; // Acceder al valor del campo "pixels"
          setPixelId(pixelId); // Guardar el ID en el estado

          // Inicializar el Pixel con el ID del usuario
          ReactPixel.init(pixelId, null, {
            autoConfig: true, // Configuración automática
            debug: false, // Habilitar logs de depuración si es necesario
          });

          // Registrar la vista de página
          ReactPixel.pageView();
        }
      } catch (error) {
        console.error("Error obteniendo el Pixel de Facebook:", error);
      }
    };

    fetchPixel();
  }, [usuario]);

  // Función para rastrear el evento "Viewcotent"   
  const trackViewContent = () => {
    if (pixelId) {
      ReactPixel.track('ViewContent');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'ViewContent'.");
    }
  };

  // Función para rastrear el evento "Cliente Potencial"
  const trackLead = () => {
    if (pixelId) {
      ReactPixel.track('Lead');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'Lead'.");
    }
  };

 /// Función para rastrear el evento "Contact"
  const trackContact = () => {
    if (pixelId) {
      ReactPixel.track('Contact');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'Contact'.");
    }
  };

   /// Función para rastrear el evento "Contact"
   const CompleteRegistration = () => {
    if (pixelId) {
      ReactPixel.track('CompleteRegistration');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'CompleteRegistration'.");
    }
  };


  return {
    pixelId,
    trackViewContent,
    trackLead,
    trackContact,
    CompleteRegistration
  };
};

export default useFacebookPixel;